<template>
  <div
    class="theTitle__lv3 flex-row flex__left padding-right-10 font-size__small"
  >
    <el-tooltip v-if="time && isQuaHan" :content="quaHanTooltip" placement="top">
      <div class="flex-row flex__left">
        <i :class="['fas fa-alarm-clock', quaHanClass]"></i>
        &nbsp;{{ time | dateFormatter({ nullValue: "-" }) }}
      </div>
    </el-tooltip>
    <div v-else class="flex-row flex__left">
      <i class="fas fa-clock color__silver"></i>
      &nbsp;{{ time | dateFormatter({ nullValue: "-" }) }}
    </div>
  </div>
</template>

<script>
  import dateUtils from "../../dateUtils";
  import dateFormatter from "../../filters/dateFormatter";

  export default {
    name: "quahan-time",
    props: ["clazz", "time"],
    filters: {dateFormatter},
    data() {
      return {
        diff: null,
        now: new Date()
      };
    },
    computed: {
      isQuaHan() {
        return this.diff > 2;
      },
      quaHanClass() {
        if (this.diff > 3) {
          return "color__red";
        } else {
          return "color__yellow";
        }
      },
      quaHanTooltip() {
        if (this.diff > 3) {
          return "Quá hạn xử lý";
        } else {
          return "Tới hạn xử lý";
        }
      }
    },
    created() {
      this.diff = this.time ? dateUtils.getDiffBaseWorkingDay(this.now, this.time) : null;
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/quahan-time.vue